import { createSelector } from 'reselect';
import {} from 'interfaces/attachment';
import {} from 'interfaces/redux';
const getState = (state) => state.attachments;
export const attachmentsSelector = createSelector([getState], (attachments) => attachments.byId);
export const allAttachmentsSelector = createSelector([attachmentsSelector], (attachments) => Object.values(attachments));
export const attachmentsIsDeletingSelector = createSelector([getState], (attachments) => attachments.isDeleting);
